export const INDEX_ROUTE = '';
export const HOME_ROUTE = '/home';
export const DETAILS_ROUTE ='/details';
export const DETAILS_ID_ROUTE = '/details/:id';
export const SEARCH_RESULTS_ROUTE ='/searchResults';
export const SEARCH_RESULTS_FULL_ROUTE = '/searchResults/*';
export const NOTFOUND_ROUTE = '*';